<script setup lang="ts">
import {Check} from "@lucide/vue";
import {Button} from "@/core/components/ui/button";

defineProps<{
    formatted: string;
}>();

defineEmits<{
    (e: 'modify'): void;
    (e: 'finish'): void;
}>();
</script>

<template>
  <div class="flex flex-col text-center">
    <div class="p-5 rounded-full bg-green-600/20 self-center">
      <Check class="text-green-600" />
    </div>
    <h1 class="text-black mt-4">
      C'est envoyé !
    </h1>
    <p class="text-muted-foreground">
      Votre RCS arrive sur le <span class="text-black font-medium">{{ formatted }}</span>. Ouvrez votre messagerie dans quelques instants.
    </p>

    <div class="flex justify-end gap-3 mt-4">
      <Button variant="outline" @click="$emit('modify')">
        Autre numéro
      </Button>
      <Button class="bg-primary" @click="$emit('finish')">
        Terminé
      </Button>
    </div>
  </div>
</template>

<style scoped>

</style>
